import { DealerLastUpdatedActionTypes } from "./actionTypes";

// Get Dealer Last Updated List
export const getDealerLastUpdatedList = (lazyState: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST,
        lazyState,
    };
};

export const getDealerLastUpdatedListSuccess = (data: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST_SUCCESS,
        payload: data,
    };
};

export const getDealerLastUpdatedListError = (error: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST_FAIL,
        payload: error,
    };
};

// Get Dealer Dropdown List
export const getDealerDropdownList = () => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST,
    };
};

export const getDealerDropdownListSuccess = (data: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST_SUCCESS,
        payload: data,
    };
};

export const getDealerDropdownListError = (error: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST_FAIL,
        payload: error,
    };
};

// Get Employee Dropdown List
export const getEmployeeDropdownList = () => {
    return {
        type: DealerLastUpdatedActionTypes.GET_EMPLOYEE_DROPDOWN_LIST,
    };
};

export const getEmployeeDropdownListSuccess = (data: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_EMPLOYEE_DROPDOWN_LIST_SUCCESS,
        payload: data,
    };
};

export const getEmployeeDropdownListError = (error: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_EMPLOYEE_DROPDOWN_LIST_FAIL,
        payload: error,
    };
};

// Get Manufacturer Dropdown List
export const getManufacturerDropdownList = () => {
    return {
        type: DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST,
    };
};

export const getManufacturerDropdownListSuccess = (data: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST_SUCCESS,
        payload: data,
    };
};

export const getManufacturerDropdownListError = (error: any) => {
    return {
        type: DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST_FAIL,
        payload: error,
    };
};

// Clear data
export const clearDealerLastUpdatedData = () => {
    return {
        type: DealerLastUpdatedActionTypes.CLEAR_DEALER_LAST_UPDATED_DATA,
    };
};

export const clearDealerLastUpdatedMessage = () => {
    return {
        type: DealerLastUpdatedActionTypes.CLEAR_DEALER_LAST_UPDATED_MESSAGE,
    };
};
